<template>
  <div>
    <h6 class="mb-8 font-bold text-1xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('diarios')">Cliente/Provedor:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ nombre.contact_nombres}} 
    </h6>
    <trashed-message v-if="diario.deleted_at" class="mb-6" @restore="restore">
     Ingreso Eliminado!
    </trashed-message>
     <h1 class="mb-8 font-bold text-1xl"> Detalle de Ingreso - Control de Peso Brut{{i=0}} </h1>
    <div v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol=='Recepcion'" class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="updateventa">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         <text-input v-model="form2.cantidad" :error="form.errors.cantidad" class="pr-6 pb-8 w-1/3" label="Cantidad de Gavetas" required/>
         <text-input v-model.number="form2.reporte_diario_id" :error="form.errors.reporte_diario_id" class="invisible left-0 top-0 h-16 w-1/6" label="Nº"/> 
          <text-input v-model="form2.peso" :error="form.errors.peso" class="pr-6 pb-8 w-1/3" label="Peso(kg)" required/>
                    
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol=='Recepcion'" :loading="form.processing" class="btn-indigo ml-auto" type="submit">Agregar</loading-button>
        </div>
      </form>
    </div>
    <br>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="flex flex-col">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block py-2 min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden shadow-md sm:rounded-lg">
          <table class="min-w-full">
        <thead class="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                             Nº
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Cantidad Gavetas
                            </th>
                            <th scope="col" class="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                               Peso(kg)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      
    <tr v-for="detalle in detalles" :key="detalle.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
         <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              {{ i=i+1}}
            </inertia-link>
          </td>
          <td>
            <inertia-link class="px-6 py-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              {{ detalle.cantidad }}
            </inertia-link>
          </td>
          <td>
             <inertia-link class="px-6 py-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              {{ detalle.peso }}
            </inertia-link>
          </td>
         
          <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
            <inertia-link class="px-4 flex items-center" :href="route('diariosdetalles.edit', detalle.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="detalles.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encuentran datos</td>
        </tr>
       </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
    </div>
    <br>
    <h1 class="mb-8 font-bold text-1xl"> Encabezado Ingreso </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
 
       <form @submit.prevent="update">
       <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <text-input v-model="form.lote" :error="form.errors.lote" class="pr-6 pb-8 w-full lg:w-1/6" label="Nº Lote" required disabled/>
        <select-input v-model="form.contact_id" :error="form.errors.contact_id" class="pr-6 pb-8 w-full lg:w-2/6" label="Cliente/Proveedor" required>
            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">{{ contact.nombres }} {{ contact.apellidos}} / {{contact.email}}</option>
          </select-input>        
       <text-input v-model="form.guia" :error="form.errors.guia" class="pr-6 pb-8 w-full lg:w-1/6" label="Guia" required/>
       <text-input v-model="form.transportista" :error="form.errors.transportista" class="pr-6 pb-8 w-full lg:w-1/4"  label="Transportista" required/>
       <text-input v-model="form.placas" :error="form.errors.placas" class="pr-6 pb-8 w-full lg:w-1/4" label="Placa" required/>
       <text-input v-model="form.origen" :error="form.errors.origen" class="pr-6 pb-8 w-full lg:w-1/4" label="HDA./Origen" required/>
       <text-input  v-model="form.pesopromedio" :error="form.errors.pesopromedio" class="pr-6 pb-8 w-full lg:w-1/4" label="Peso Promedio Gaveta Vacía" required pattern="^[0-9]+(.[0-9]+)?$"/>

                  
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="$page.props.auth.user.rol == 'Admin' || $page.props.auth.user.rol == 'Recepcion'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Ingreso</button>
          <loading-button v-if="$page.props.auth.user.rol =='Admin' || $page.props.auth.user.rol=='Recepcion'" :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar Ingreso</loading-button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datetimepicker'

export default {
  
  metaInfo() {
    return {
      title: `${this.nombre.contact_nombres}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker
  },
  layout: Layout,
  props: {
    diario: Object,
    nombre: Object,
    detalles: Array,
    contacts: Array,
  },
  remember: 'form',
  
  data() {
    return {
      form: this.$inertia.form({
        contact_id: this.diario.contact_id,
        lote: this.diario.lote,
    
        transportista: this.diario.transportista,
        origen: this.diario.origen,
        placas: this.diario.placas,
        guia: this.diario.guia,  
        pesopromedio: this.diario.pesopromedio,  

      }),
       form2: this.$inertia.form({
        reporte_diario_id: this.diario.id,
        cantidad: null,
        peso: null,
      


      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('diarios.update', this.diario.id))
    },
    updateventa() {
     this.form2.post(this.route('diariosdetalles.store'))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('diarios.destroy', this.diario.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('diarios.restore', this.diario.id))
      }
    },
    
  },
  
}
</script>
